"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationCount = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _primitiveMessages = require("./primitiveMessages");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PaginationCount = function PaginationCount(_ref) {
  var currentCount = _ref.currentCount,
      totalCount = _ref.totalCount;
  var containerProps = {
    className: 'pagination-count',
    'aria-live': 'polite',
    'aria-atomic': true
  };

  var message = _objectSpread({}, _primitiveMessages.primitiveMessages.paginationCount, {
    values: {
      currentCount: currentCount,
      totalCount: totalCount
    }
  });

  return _react.default.createElement("div", containerProps, _react.default.createElement(_reactIntl.FormattedMessage, message));
};

exports.PaginationCount = PaginationCount;
PaginationCount.propTypes = {
  currentCount: _propTypes.default.number.isRequired,
  totalCount: _propTypes.default.number.isRequired
};